import { Button, Flex, Text } from "@radix-ui/themes";
import { PlusIcon } from "@radix-ui/react-icons";
import { Table } from "@/v2/shared/shadcn-ui/table";
import { EditableTableField, EditableTableRow } from "./EditableTable.model";
import { EditableTableHeader } from "./EditableTableHeader";
import { EditableTableBody } from "./EditableTableBody";
import { EditableTableEmptyState } from "./EditableTableEmptyState";
import { useEditableTableHandlers } from "./useEditableTableHandlers";

export interface EditableTableProps {
  value: EditableTableRow[];
  onChange: (value: EditableTableRow[]) => void;
  fields: EditableTableField[];
  title: string;
  addButtonText: string;
  emptyStateText: string;
  showToggle?: boolean;
}

export function EditableTable({
  value,
  onChange,
  fields,
  title,
  addButtonText,
  emptyStateText,
  showToggle = true,
}: EditableTableProps) {
  const { rows, addRow, updateRow, deleteRow, toggleRow } =
    useEditableTableHandlers({
      value,
      onChange,
      fields,
    });

  return (
    <div className="h-full">
      <Flex direction="column" gap="4">
        <Flex justify="between" align="center">
          <Text size="3" weight="medium">
            {title}
          </Text>
          <Button
            size="2"
            variant="solid"
            color="gray"
            highContrast
            onClick={addRow}
          >
            <PlusIcon />
            {addButtonText}
          </Button>
        </Flex>

        <div className="border border-gray-6 rounded-md overflow-hidden shadow-sm">
          <Table>
            <EditableTableHeader fields={fields} showToggle={showToggle} />
            <EditableTableBody
              rows={rows}
              fields={fields}
              showToggle={showToggle}
              updateRow={updateRow}
              deleteRow={deleteRow}
              toggleRow={toggleRow}
            />
          </Table>
        </div>

        {rows.length === 0 && (
          <EditableTableEmptyState
            emptyStateText={emptyStateText}
            addButtonText={addButtonText}
            onAddRow={addRow}
          />
        )}
      </Flex>
    </div>
  );
}
